import { useNetworksStateContext } from "@l2r-front/l2r-networks"

import { riskZonesQueryKeys } from "./queryKeys"
import { useRiskZonesQuery } from "./useRiskZonesQueries"

export function useRiskZonesTraffic(params = {}, config = {}) {
    const url = "risk_zone_clusters/stats/vehicles/"
    const { enabled = true } = config
    const { selectedNetwork } = useNetworksStateContext()

    return useRiskZonesQuery(
        url,
        riskZonesQueryKeys.vehicleStats(params),
        { ...params, project: selectedNetwork?.slug },
        {
            ...config,
            enabled: !!selectedNetwork?.slug && enabled,
        },
    )
}